import type { ComponentProps, ReactElement } from 'react';

import { CopyTooltip } from '@bestseller-bit/frontend-community.components.copy-tooltip';
import {
    CheckIcon,
    CircleExclamationIcon,
} from '@bestseller-bit/frontend-community.theme.buying-theme';
import { useTheme } from '@mui/material/styles';

type BuyingCopyTooltipProps = Omit<
    ComponentProps<typeof CopyTooltip>,
    'failedIcon' | 'successIcon'
>;

export const BuyingCopyTooltip = (
    tooltipProps: BuyingCopyTooltipProps
): ReactElement => {
    const { palette, typography, spacing } = useTheme();

    const iconProps = {
        style: {
            marginLeft: spacing(1),
        },
        size: typography['captionsSmall.default'].fontSize,
    };

    return (
        <CopyTooltip
            successIcon={
                <CheckIcon
                    {...iconProps}
                    color={palette.success.main}
                />
            }
            failedIcon={
                <CircleExclamationIcon
                    {...iconProps}
                    color={palette.error.main}
                />
            }
            arrow
            {...tooltipProps}
        />
    );
};
